import axios from 'axios'

const getCommunityHeader = async (id) => {
  const response = await axios.get(`community/${id}`)
  return response.data
}

const getAutonomyDashboard = async (id, { months, from, to } = {}) => {
  const params = {}
  if (months) params.months = months
  if (from && to) {
    params.from = from
    params.to = to
  }
  const response = await axios.get(`community/${id}/autonomy-dashboard`, { params })
  return response.data
}

const getActivities = async (id, params) => {
  const response = await axios.get(`community/${id}/activities`, { params })
  return response.data
}

const getActivity = async (id, activityId) => {
  const response = await axios.get(`community/${id}/activities/${activityId}`)
  return response.data
}

const saveIntervention = async (id, payload, activityId) => {
  const response = activityId
    ? await axios.put(`community/${id}/activities/${activityId}`, payload)
    : await axios.post(`community/${id}/activities`, payload)
  return response.data
}

const getAutoIndicators = async (communityId, period) => {
  const response = await axios.get('autonomy-checklist/auto-indicators', { params: { communityId, period } })
  return response.data
}

const getAutonomyCatalog = async () => {
  const response = await axios.get('autonomy/catalog')
  return response.data
}

const getAutonomyChecklist = async (checklistId) => {
  if (!checklistId) return null
  const response = await axios.get(`autonomy-checklist/${checklistId}`)
  return response.data
}

const createAutonomyChecklist = async (payload) => {
  const response = await axios.post('autonomy-checklist', payload)
  return response.data
}

const updateAutonomyChecklist = async (checklistId, payload) => {
  const response = await axios.put(`autonomy-checklist/${checklistId}`, payload)
  return response.data
}

const addAutonomyChecklistComment = async (checklistId, payload) => {
  const response = await axios.post(`autonomy-checklist/${checklistId}/comments`, payload)
  return response.data
}

const getTeamIndicators = async (id, from, to) => {
  const response = await axios.get(`community/${id}/team-indicators`, { params: { from, to } })
  return response.data
}

export {
  getCommunityHeader,
  getAutonomyDashboard,
  getActivities,
  getActivity,
  saveIntervention,
  getAutoIndicators,
  getAutonomyCatalog,
  getAutonomyChecklist,
  createAutonomyChecklist,
  updateAutonomyChecklist,
  addAutonomyChecklistComment,
  getTeamIndicators
}
